import { render } from "./ResetPass.vue?vue&type=template&id=791c132f&scoped=true"
import script from "./ResetPass.vue?vue&type=script&lang=js"
export * from "./ResetPass.vue?vue&type=script&lang=js"

import "./ResetPass.vue?vue&type=style&index=0&id=791c132f&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-791c132f"]])

export default __exports__